import { ServerConfig } from "@/config/config";
import { DiscountCode } from "@/models/discount-code";
import { IPaginationData, paginationToQuery } from "@/utils/browse/pagination-data";
import { IPaginatedResponse } from "@/utils/browse/pagination-response";
import { Axios } from "./auth-service";

const URL = `${ServerConfig.host}/admin/discount-codes`;

export class DiscountCodeServiceClass {
	public async getDiscountCodes(paginationData?:IPaginationData):Promise<IPaginatedResponse<DiscountCode>>{
		let params = {} as any;
		if (paginationData){
			params = paginationToQuery(paginationData);
		}
		let result = await Axios.get(`${URL}`, {params});
		let data = result.data.data.map((d:any)=>new DiscountCode(d)) as DiscountCode[];
		let records = result.data.records as number;
		return {
			data,
			records
		};
	}

	public async getDiscountCode(id:number):Promise<DiscountCode>{
		let result = await Axios.get(`${URL}/${id}`);
		return new DiscountCode(result.data);
	}

	public async createDiscountCode(code:DiscountCode):Promise<DiscountCode>{
		let result = await Axios.post(`${URL}`, code.getJSON());
		return new DiscountCode(result.data);
	}

	public async updateDiscountCode(code:DiscountCode):Promise<DiscountCode>{
		let result = await Axios.put(`${URL}/${code.id}`, code.getJSON());
		return new DiscountCode(result.data);
	}

	public async deleteDiscountCode(code:DiscountCode):Promise<void>{
		await Axios.delete(`${URL}/${code.id}`);
	}

	public async deleteDiscountCodes(codes:DiscountCode[]):Promise<void>{
		await Axios.delete(`${URL}`, {data: codes.map(c=>c.id)});
	}
}

export const DiscountCodeService = new DiscountCodeServiceClass();